import { Breadcrumb, Layout, theme, Typography, Card  } from 'antd';
const { Content } = Layout;
const { Title } = Typography;

const PageApp = ({children, routes, title, cardTitle = '', extraCard=[]}) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  return (<>
    <Breadcrumb items={routes} style={{margin: '16px 20px 20px',}}/>
    {
      title && 
      <Title level={2}  style={{
        margin: '24px 16px',
      }}>{title}</Title>
    }
    <Content >
      {
        !cardTitle && (!extraCard || extraCard.length == 0) ?
        <Card
            bordered={false}
            style={{margin: '0 16px'}}
          >
             { children }
        </Card>
        :
        <Card
            title={cardTitle}
            bordered={false}
            style={{margin: '0 16px'}}
            extra={[
              ...extraCard
            ]}
          >
             { children }
        </Card>
        
      }
         
    </Content>
   </> )
};
  export default PageApp;